/**
 * The team's IANA time zone for task times (#2721). `MapThemeProvider` fills it
 * from the team read, so the board card, the outline row and the drawer show
 * the same wall clock as the Telegram message. `undefined` means the viewer's
 * own zone, the fallback until the team loads or when it has none.
 */
import { createContext, useContext } from "react";

export const TeamZoneContext = createContext<string | undefined>(undefined);

export function useTeamZone(): string | undefined {
  return useContext(TeamZoneContext);
}
